import { render, staticRenderFns } from "./ConfigCopyIcon.vue?vue&type=template&id=03ff09d8"
import script from "./ConfigCopyIcon.vue?vue&type=script&lang=js"
export * from "./ConfigCopyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports